export default {
    toolbar: {
        title: 'Mail',
        searchPlaceholder: 'Search mail',
        compose: 'Compose',
        delete: 'Delete',
        starred: 'Starred',
        showAll: 'Show All',
        markRead: 'Mark Read',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        selected: 'selected',
    },
    boxes: {
        inbox: 'Inbox',
        sent: 'Sent',
        starred: 'Starred',
    },
    row: {
        to: 'To',
        official: 'Official',
        readByRecipient: 'Read',
        unreadByRecipient: 'Unread',
        star: 'Star Message',
        select: 'Select message',
    },
    message: {
        to: 'to',
        back: 'Back to list',
        close: 'Close message',
        markUnread: 'Mark unread',
        markRead: 'Mark read',
        reply: 'Reply',
        delete: 'Delete message',
        selectPrompt: 'Select a message to read it here',
        error: 'This message could not be loaded. Please try again.',
        adminNote:
            'This MyFreeCams Mail is from an official MyFreeCams Administrator. Only mail from MyFreeCams is highlighted like this.',
        memberNote:
            'This MyFreeCams Mail is from a member, NOT an Administrator, and it has NOT been reviewed. NEVER enter your username and password on any links this message may contain.',
    },
    compose: {
        title: 'Send MFC Mail',
        close: 'Close',
        to: 'To',
        toPlaceholder: 'Search for a user',
        chooseFriend: 'Choose a friend',
        subject: 'Subject',
        subjectPlaceholder: 'Enter your subject here',
        message: 'Message',
        messagePlaceholder: 'Enter your message here',
        send: 'Send',
        discardPrompt:
            'Are you sure you want to discard this draft? All changes will be lost.',
        discard: 'Discard',
        keepEditing: 'Keep Editing',
    },
    empty: {
        noMail: 'No mail yet... ',
        noResults: 'No mail messages match',
        noStarredResults: 'No starred mail messages match',
        noStarred: 'No starred messages',
    },
}
